import React, { useState } from 'react';
import TaxonItem from './taxon-item.jsx';
import adminService from '../../services/AdminService/admin-service.js';
import coalService from '../../services/CoalService/coal-service.js';
import TaxonGenus from './taxon-genus.jsx';

export default function TaxonFamily({ family, onNavigate, settings, t }) {
    const [expanded, setExpanded] = useState(false);
    const [records, setRecords] = useState([]);
    const [genera, setGenera] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleExpand = () => {
        if (expanded) {
            setExpanded(false);
            return;
        }
        if (genera.length > 0) {
            setExpanded(true);
            return;
        }
        setLoading(true);
        adminService.listActiveGenusByFamily(family.id).then(response => {
            if(response.data.length === 0){ // sem gêneros
                coalService.filterCoalByFamily({ family_id: family.id, public: false }).then(res => {
                    setGenera([]);
                    setRecords(res.data);
                    setExpanded(true);
                    setLoading(false);
                });
            }else{
                setGenera(response.data);
                setRecords([]);
                setExpanded(true);
                setLoading(false);
            }
        }).catch(() => {
            settings.handleSetAlert('danger', t('alerta.titulo.erro'), t('alerta.algoDeuErrado.mensagem'));
            setLoading(false);
        });
    };

    return (
        <div>
            <TaxonItem
                name={family.name.toUpperCase()}
                expandable={true}
                expanded={expanded}
                onExpand={handleExpand}
                onClick={() => onNavigate('family', family.id)}
                indent={0}
            />

            {loading && (
                <div style={{ paddingLeft: '2.5rem' }} className="text-white small">
                    <i className="fas fa-spinner fa-pulse fa-xs me-1"/>
                </div>
            )}

            {expanded && genera.length > 0 && genera.map(gen => (
                <TaxonGenus
                    key={gen.id}
                    genus={gen}
                    onNavigate={onNavigate}
                    settings={settings}
                    t={t}
                />
            ))}

            {expanded && genera.length === 0 && records.map(record => (
                <TaxonItem
                    key={record.id}
                    name={record.scientific_name || record.determination || record.genus_name}
                    expandable={false}
                    onClick={() => onNavigate('record', record)}
                    indent={1}
                />
            ))}
        </div>
    );
}